import React, { useEffect, useState } from 'react'
import { useThemeColors } from '../../../../../../../../hooks/useThemeColors'

const ConnectionLines = ({ matchedItems, matchingProperty, containerRef }) => {
    const colors = useThemeColors()
    const [connections, setConnections] = useState([])

    const drawConnections = () => {
        if (!containerRef.current) return

        const newConnections = matchedItems
            .filter(item => item[matchingProperty])
            .map(matchedItem => {
                const matchedElement = document.getElementById(`matched-${matchedItem.id}`)
                const originalElement = document.getElementById(`orig-${matchedItem[matchingProperty]}`)

                if (matchedElement && originalElement) {
                    const matchedRect = matchedElement.getBoundingClientRect()
                    const originalRect = originalElement.getBoundingClientRect()
                    const containerRect = containerRef.current.getBoundingClientRect()

                    return {
                        x1: matchedRect.left - containerRect.left,
                        y1: matchedRect.top - containerRect.top + matchedRect.height / 2,
                        x2: originalRect.right - containerRect.left,
                        y2: originalRect.top - containerRect.top + originalRect.height / 2,
                    }
                }
                return null
            })
            .filter(Boolean)

        setConnections(newConnections)
    }

    useEffect(() => {
        drawConnections()
    }, [matchedItems])

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            drawConnections()
        })

        if (containerRef.current) {
            resizeObserver.observe(containerRef.current)
        }

        return () => {
            if (containerRef.current) {
                resizeObserver.unobserve(containerRef.current)
            }
        }
    }, [containerRef])

    return (
        <svg
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
            }}
        >
            {connections.map((connection, index) => (
                <line
                    key={index}
                    x1={connection.x1}
                    y1={connection.y1}
                    x2={connection.x2}
                    y2={connection.y2}
                    stroke={colors.primary}
                    strokeWidth='2'
                />
            ))}
        </svg>
    )
}

export default ConnectionLines
